
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import AllPromotionsTab from "./promotion/AllPromotionsTab";
import CreatePromotionTab from "./promotion/CreatePromotionTab";
import CatalogueGeneratorTab from "./promotion/CatalogueGeneratorTab";
import RedeemReportsTab from "./promotion/RedeemReportsTab";
import PromotionAnalyticsTab from "./promotion/PromotionAnalyticsTab";

const Promotion = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold text-green-700">Promotion Management</h1>
      <p className="text-muted-foreground">
        Create and manage promotional campaigns, discounts, and special offers.
      </p>
      
      <Tabs defaultValue="all-promotions" className="w-full">
        <TabsList className="grid grid-cols-5 mb-4">
          <TabsTrigger value="all-promotions">All Promotions</TabsTrigger>
          <TabsTrigger value="create-new">Create New</TabsTrigger>
          <TabsTrigger value="catalogue">Catalogue</TabsTrigger>
          <TabsTrigger value="redeem-reports">Redeem Reports</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>
        
        <Card className="border-green-100">
          <CardContent className="p-6">
            <TabsContent value="all-promotions" className="mt-0">
              <AllPromotionsTab />
            </TabsContent>
            
            <TabsContent value="create-new" className="mt-0">
              <CreatePromotionTab />
            </TabsContent>
            
            <TabsContent value="catalogue" className="mt-0">
              <CatalogueGeneratorTab />
            </TabsContent>
            
            <TabsContent value="redeem-reports" className="mt-0">
              <RedeemReportsTab />
            </TabsContent>
            
            <TabsContent value="analytics" className="mt-0">
              <PromotionAnalyticsTab />
            </TabsContent>
          </CardContent>
        </Card>
      </Tabs>
    </div>
  );
};

export default Promotion;
